import React from 'react';
// Components
import Button from '../../Button';
import { Input } from 'antd';
import resetCpayIcon from '../../../img/cpay-svg/reset.svg';
import resetNfgIcon from '../../../img/nfgpay-svg/reset-nfg.svg';
import resetFinvaroIcon from '../../../img/finvaro/reset-finvaro.svg';
import resetClarniumIcon from '../../../img/clarnium/reset-clarnium.svg';
import resetInexIcon from '../../../img/inex/reset-inex.svg';
import resetInstaIcon from "../../../img/instaXchange/reset-insta.svg";
import resetCoineraIcon from "../../../img/coinera/reset-coinera.svg";
// Utils
import { useTranslation } from 'react-i18next';
// Style
import './style.scss';
import { identity } from '../../../utils/getIdentity';
import { AppConfig } from "../../../config";

const resetIcon = {
  cpay: resetCpayIcon,
  nfg: resetNfgIcon,
  finvaro: resetFinvaroIcon,
  clarnium: resetClarniumIcon,
  inex: resetInexIcon,
  insta: resetInstaIcon,
  coinera: resetCoineraIcon
};

const CheckoutsHeader = ({
                           data,
                           setIsVisible,
                           fetching,
                           search,
                           type,
                           setSearch,
                           walletVersion,
                           getCheckoutListHandler,
                           getPlanListHandler,
                         }) => {
  const { t } = useTranslation();

  const resetSearch = () => {
    setSearch(null);
    type === 'plan' ? getPlanListHandler() : getCheckoutListHandler(1,walletVersion);
  };

  return (
    <div className="checkouts-header">
      <div className={`checkouts-header__title checkouts-header__title-${identity}`}>
        <div className="checkouts-header__wrapper">
          {type === 'plan' ? t('checkouts.recurringTitle') : t('checkouts.checkouts')}
          <div className="checkouts-header__documentation">
            {type === 'plan' && identity === 'cpay' && (
              AppConfig?.hideLogo ?
                <a href="https://docs.payblock.tech/functional/recurring-billing/" target="_blank">Documentation</a> :
                <a href="https://docs.gemewallet.com/functional/recurring-billing/" target="_blank">Documentation</a>
            )}
          </div>
        </div>
        <div className={`checkouts-header__controls checkouts-header__controls-${identity}`}>
          <Input.Search
            disabled={fetching}
            name="search"
            placeholder={t('search')}
            onSearch={() => {
              type === 'plan' ? getPlanListHandler(search) : getCheckoutListHandler(1, walletVersion, search);
            }}
            className="checkouts-header__search-field"
            onChange={e => setSearch(e.target.value)}
            value={search}
            addonAfter={
              <span onClick={resetSearch} className="checkouts-header__reset-button">
                <img src={resetIcon[identity]} alt="Reset" />
              </span>
            }
          />
          {data && data.length ? (
            <Button type="secondary" className={`checkouts-list__button checkouts-list__button-${identity}`} onClick={() => setIsVisible(true)}>
              {type === 'plan' ? t('checkouts.createPlan') : t('checkouts.createCheckout')}
            </Button>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default CheckoutsHeader;